module.exports = __webpack_public_path__ + "img/sos.6acb70cb.png";